import { FC } from 'react'
import { AnimatedPage, Direction } from 'components/Animated'
import { OwnSensorV2Flow } from 'screens/OwnSensorV2/Steps'

export const OwnSensorV2FlowStep: FC<any> = ({ stepIndex }) => {
  const currentStep = OwnSensorV2Flow[stepIndex]
  const StepComponent = currentStep.routeComponent

  if (currentStep.noPageAnimation) {
    return <StepComponent />
  }

  return (
    <AnimatedPage direction={Direction.Forward} resetBackDirection={() => {}}>
      <StepComponent />
    </AnimatedPage>
  )
}
